// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_upload_header-module__title--1vlIK{font-weight:700;font-size:30px;line-height:1.2;letter-spacing:.2px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;color:#303030;text-align:center;margin-bottom:24px}@media screen and (max-width: 48em){.decision_upload_header-module__title--1vlIK{font-size:21px}}.decision_upload_header-module__note--2POhm{margin:0px auto 40px;font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;color:#616161}\n", ""]);
// Exports
exports.locals = {
	"title": "decision_upload_header-module__title--1vlIK",
	"note": "decision_upload_header-module__note--2POhm"
};
module.exports = exports;
